const nodeMap = (node, fn) => {
  const mappedNode = fn(node);
  const nodeHasItems = node.items && Array.isArray(node.items);
  return {
    ...mappedNode,
    items: !nodeHasItems ? undefined : node.items.map((subNode) => nodeMap(subNode, fn)),
  };
};

export const treeMap = (tree, fn) => tree.map((node) => nodeMap(node, fn));
